/***
 * Created on 2023/8/23
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";

function InitSmsSetup({dispatch, ..._prop}) {
    const { t } = useTranslation();

    const onClick = (e) => {
        e.preventDefault();
        dispatch({type: 'toggleShowInitSetup', value: true});
    }

    const onVerify = (e) => {
        e.preventDefault();
        dispatch({type: 'toggleAddPhone', value: true})
    }

    return (
        <ModalDialog {..._prop} title={t('@Setup 2-Step Verification@')} hideSubmit={true}>
            <div className="dialog-content">
                <div className="dialog__info-grid">
                    <div className="info-grid__row flex-direction-column !flex-wrap-wrap pt-16 pr-24 pb-24 pl-24">
                        <div className="dialog__sub-title color-primary">
                            {t('@Verify via SMS@')}
                        </div>
                        <p>{t('@A convenient way to receive verification code. SMS support all kind of mobile device without requiring installation of additional app.@')}</p>
                        <button className="q-btn q-btn--primary btn-rounded-full !w-fit" onClick={onVerify}>{t('@Verify@')}</button>
                    </div>
                </div>
                <p>or <a href="#" onClick={onClick}>{t('@Verify via App@')}</a></p>
            </div>
        </ModalDialog>
    );
}

export default InitSmsSetup;